<template>
  <div class="animated fadeIn">
    <h3>Potato Report</h3>
    <b-card v-for="(result, index) in results" no-body :key="index">
      <b-card-header>
        <span class="text-muted">
          <b>{{ result.result_group }}</b>
        </span>
      </b-card-header>
      <b-card-body class="p-0" ref="results">
        <b-table
          :items="formResultData(result)"
          :fields="columns"
          class="mb-0"
          bordered 
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { soil_nutrient_report_elements } from "@/shared/result-table-fields";

export default {
  name: "SubmissionWesternTractorReport",
  props: {
    results: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    columns() {
      return [
        { key: "id", label: "Sample ID" },
        { key: "depth", label: "Depth" },
        { key: "zone", label: "Zone" },
        ...soil_nutrient_report_elements.map(item => {
          return {
            key: item.element,
            label: `${item.element} ${item.unit || '-'}`
          }
        })
      ]
    },
  },
  methods: {
    formResultData(result) {
      return [
        ...result.samples.map(({ id, depth, zone, analytes, base_saturation }) => {
          return {
            id, depth, zone,
            ...this.formatData(analytes),
            ...this.formatData(base_saturation)
          }
        }),
        {
          zone: result.total.zone,
          ...this.formatData(result.total.analytes),
          ...this.formatData(result.total.base_saturation)
        }
      ]
    },
    formatData(data) {
      return data.reduce((acc, cur) => {
        return {
          ...acc,
          [cur.name]: cur.result
        }
      }, {})
    }
  }
}
</script>